<template>
  <div>
    <section id="sub_visual" class="pic12">
      <p>이트너스 비품관리 소개</p>
      <span>About etners Asset Management Service</span> </section>
    <main id="page_sub">
      <section id="page_contents" class="sub_con12 clear">
        <h6>성공적인 자산/비품 <br/>
          관리의 지름길</h6>
        <p>자산의  취득을 기준으로 이관, 변경, 처분 등의 다양한 관리 정보를 효율적으로 처리하고,<br>
          체계적인  창고관리를 통하여 유휴 집기의 장•단기적 활용 전략을 수립하는데 도움을 줍니다.</p>
        <p class="ctext2 w75p"><span>Why etners </span><span>Asset Management?</span></p>
        <!--- 특징 --->
        <div class="clearfix">
          <ul class="platform">
            <li>
              <p><img src="../../assets/images/c_im_34.png" width="104" height="104" alt=""/></p>
              <h6>취득부터 처분까지 철저한 이력관리! </h6>
              <p>취득 시점부터 자산의 이관, 변경, 처분 등 다양한 정보를
                한번에 관리하고, 계정 과목에 따른 당기 감가상각을 확인할
                수 있습니다.(정액법/정률법 선택적용가능) </p>
            <li>
              <p><img src="../../assets/images/c_im_22.png" width="104" height="104" alt=""/></p>
              <h6>사용자 편의 중심의 관리 인터페이스 제공!</h6>
              <p>부서/창고 별 집기 보유현황 LIST, 입/출고 히스토리, 처분 현황을 실시간으로 확인할 수 있도록 사용자 편의 중심의
                시스템 화면을 제공합니다. </p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_25.png" width="104" height="104" alt=""/></p>
              <h6>시스템을 통한 현장실사 전문 체계 구축 </h6>
              <p>전수 조사를 바탕으로 보유 현황에 대한 기초 데이터를 마련
                하고, QR코드를 활용한 관리체계 구축으로 현장실사 및
                관리의 신속•정확성을 제고합니다.. </p>
            </li>
            <li>
              <p><img src="../../assets/images/c_im_28.png" width="104" height="104" alt=""/></p>
              <h6>전문 솔루션과의 연계를 통한 성과 창출 UP! </h6>
              <p>이트너스 샵(Shop)과 연동하여 구매/관리 비용을 절감하고
                비딩(Bidding)솔루션을 통한 경쟁입찰로 매각/폐기 대상의
                고정자산의 처분이익을 극대화 할 수 있습니다. </p>
            </li>
          </ul>
        </div>
        <!--- //특징 --->
      </section>
    </main>
  </div>
</template>

<script>
  export default {
    name : "etnersconcierge",
    data() {
      return{

      }
    },
    methods:{
      goConcierge:function () {
        this.$router.push({name:'Concierge'})
      }
    }
  }

</script>
